module.exports = __webpack_public_path__ + "fonts/poppins-thin-webfont.4bcf0581.woff2";